export default __webpack_public_path__ + "static/media/shutterstock_678279070.70af1be5.jpg";